import { TINY_CIRCLE_RADIUS, TINY_CIRCLE_STROKE_WIDTH } from "../../layerDefsConfig";
import { gis2QueryUrl } from '../../../utils/urls.js'

/*
const queryOutfields = [
  // Who
  "retail_fascia",
  "retail_brand",
  "retail_group_name",
  "retail_activity",
  "retail_category",
  "retail_sub_class",
  "retail_top_class",

  // What
  "retail_sic_code_description",
  "retail_use_class",
  "retail_fspace_sq_ft",
  "retail_trading_floors",
  "retail_verification_date",
  "source",
  "car_park_spaces",

  // Where
  "retail_address_1",
  "retail_address_2",
  "retail_locality",
  "retail_postcode",
]
*/
const queryOutfields = "*";

const newRetailLocationsLayerDef = (id, label, layerNumber, info=undefined) => {
  return {
    layer: {
      id: id, // <-------------------------- id
      type: "circle",
      paint: {
        "circle-color": "#9E0059",
        "circle-radius": TINY_CIRCLE_RADIUS,
        "circle-stroke-width": TINY_CIRCLE_STROKE_WIDTH,
        "circle-stroke-color": "#fff",
      },
      layout: {
        visibility: "none",
      },
    },
    source: {
      id: id, // <-------------------------- id
      type: "geojson",
      data: gis2QueryUrl("hsds_premises_data_service", layerNumber, { outFields: queryOutfields }), // <----- layerNumber
    },
    labels: {
      parent: label, // <-------------------------- label
    },
    filters: {
      filterByChildren: false,
    },
    filterBySelectedRegion: true,
    category: "hsds",
    grouping: "hsds-experian-retail-locations",
    popupType: "experian-retail-location",
    requiresGis2Token: true,
    info, // <---------------------------------- info
  }
}

export const hsdsLayerDefsExperian = {
  "hsds-experian-retail-locations-comparison": newRetailLocationsLayerDef(
    "hsds-experian-retail-locations-comparison",
    "Comparison",
    0, // .../MapServer/0/query?...
    {
      shortDescription:
        "These have a higher value and are purchased less often, such as household items, electrical goods, clothes and shoes. People tend to go to several shops to compare products before buying them.",
    },
  ),
  "hsds-experian-retail-locations-convenience": newRetailLocationsLayerDef(
    "hsds-experian-retail-locations-convenience",
    "Convenience",
    1, // .../MapServer/1/query?...
    {
      shortDescription:
        "A small local store where you can buy food, newspapers, etc. and that is open until late at night or all the time.",
    },
  ),
  "hsds-experian-retail-locations-leisure-services": newRetailLocationsLayerDef(
    "hsds-experian-retail-locations-leisure-services",
    "Leisure services",
    2,
    {
      shortDescription: "Restaurants, sporting, recreational and cultural activities and gambling.",
    },
  ),
  "hsds-experian-retail-locations-retail-service": newRetailLocationsLayerDef(
    "hsds-experian-retail-locations-retail-service",
    "Retail service",
    4,
    {
      shortDescription:
        "A retailer, whose product line is actually a service, including hairdressers, drycleaners or garages.",
    },
  ),
  "hsds-experian-retail-locations-other": newRetailLocationsLayerDef(
    "hsds-experian-retail-locations-other",
    "Other",
    3,
    {
      shortDescription:
        "Health & medical, transport, financial, public services.",
    },
  ),
  "hsds-experian-retail-locations-vacant": newRetailLocationsLayerDef(
    "hsds-experian-retail-locations-vacant",
    "Vacant",
    5,
  ),

    "hsds-experian-retail-locations-persistently-vacant": newRetailLocationsLayerDef(
    "hsds-experian-retail-locations-persistently-vacant",
    "Persistently Vacant",
    6,
{
        shortDescription: "Premises that have been vacant for the past year or 366 days over the past 2 years - and so meet the High Street Rental Auctions conditions"
      }
  ),
}
